import { useFormik } from "formik";
import * as yup from "yup";
import { isValidPhoneNumber } from "libphonenumber-js";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { usePaymentFlow } from "../../../hooks/usePaymentFlow";
import { useInvoice } from "../../../hooks/invoice/useInvoice";

export const useSunbitForm = ({ showTipsModal, onPayment }) => {
  const { tSales } = useAppTranslation.Sales();
  const { tCommon } = useAppTranslation.Common();
  const { isTipsAvailable } = usePaymentFlow();
  const { invoice, amountToPay } = useInvoice();

  const schema = yup.object({
    phoneNumber: yup
      .string()
      .required(tSales("checkoutInvoice.formError.phoneNumberRequired"))
      .test(
        "valid-phone-number",
        tSales("checkoutInvoice.formError.validPhoneNumberRequired"),
        (value) =>
          isValidPhoneNumber(
            value || "",
            invoice?.patient?.country?.countryCode?.toUpperCase(),
          ),
      ),
    email: yup
      .string()
      .email(tCommon("formError.emailInvalid"))
      .required(tSales("checkoutInvoice.formError.emailRequired")),
  });

  const form = useFormik({
    initialValues: {
      phoneNumber: invoice?.patient?.phoneNumber || "",
      email: invoice?.patient?.email || "",
      amount: amountToPay || "",
    },
    validationSchema: schema,
    validateOnChange: false,
    validateOnBlur: true,
    onSubmit: (values) => {
      if (isTipsAvailable && !showTipsModal.value) {
        showTipsModal.update(true);
      } else {
        onPayment({
          email: values.email,
          phoneNumber: values.phoneNumber,
        });
      }
    },
  });

  return form;
};
